module.exports = __webpack_public_path__ + "assets/img/vis_label.b87d9d7d.png";